export function getSiblingInArray(
  array: [],
  currentIndex: number,
  direction: "next" | "prev"
) {
  if (direction === "prev") {
    //If there is another before this one, return that.
    if (currentIndex > 0) {
      return array[currentIndex - 1];
    }
    //Otherwise, return the first one (beginning of list)
    return array[array.length - 1];
  }

  if (direction === "next") {
    //If there is another skin past this one, return that.
    if (array[currentIndex + 1]) {
      return array[currentIndex + 1];
    }
    //Otherwise, return the first one (beginning of list)
    return array[0];
  }

  console.warn(
    "getSiblingInArray not configured correctly. Direction should be `next` or `prev` "
  );
}



// WEBPACK FOOTER //
// ./src/helpers/get-sibling-in-array.js